/* Product-name search uses Shopify's native index and pagination. */
(() => {
  const init = (root) => {
    if (root.dataset.scopeReady) return;
    root.dataset.scopeReady = 'true';
    const current = new URL(location.href);
    const query = root.dataset.query || '';
    // Only decode the expression generated here; preserve advanced user queries.
    const generated = /^title:"[^"\\]+"(?: AND title:"[^"\\]+")*$/u.test(query);
    const term = generated
      ? [...query.matchAll(/title:"([^"\\]+)"/gu)].map(match => match[1]).join(' ')
      : query;
    const advanced = !generated && /[:"\\()]/u.test(query);
    const scope = current.searchParams.get('md_scope') === 'all' || advanced ? 'all' : 'names';
    const destination = (text, mode) => {
      const url = new URL(root.dataset.searchUrl, location.origin);
      // Retain preview/localization context, but not old pagination or filters.
      for (const key of ['preview_theme_id', 'pb', 'locale']) {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      }
      const words = text.trim().split(/\s+/u).filter(Boolean);
      const useNames = mode === 'names' && !/[:"\\()]/u.test(text);
      url.searchParams.set('q', useNames ? words.map(word => `title:"${word}"`).join(' AND ') : text.trim());
      url.searchParams.set('md_scope', useNames ? 'names' : 'all');
      if (useNames) url.searchParams.set('type', 'product');
      return url;
    };
    if (term.trim() && !generated && scope === 'names' && root.dataset.designMode !== 'true') {
      location.replace(destination(term, 'names').href);
      return;
    }
    // Header search should also display human-readable words after a name search.
    if (generated) {
      document.querySelectorAll('input[name="q"]').forEach(input => {
        if (input.value === query) input.value = term;
      });
    }
    root.querySelectorAll('[data-search-scope]').forEach(link => {
      link.href = destination(term, link.dataset.searchScope).href;
    });
    const form = root.querySelector('form');
    form.addEventListener('submit', event => {
      const text = form.elements.q.value.trim();
      if (!text) { event.preventDefault(); form.elements.q.focus(); return; }
      event.preventDefault();
      location.assign(destination(text, scope).href);
    });
    // Shopify preserves the query; explicitly retain the broad-search opt-in.
    root.querySelectorAll('.md-pg a').forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('md_scope', scope);
      link.href = url.href;
    });
  };
  document.querySelectorAll('[data-md-search-page]').forEach(init);
  if (!window.mdSearchScopeEditorBound) {
    window.mdSearchScopeEditorBound = true;
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-md-search-page]').forEach(init);
    });
  }
})();
